import { useQuery } from "@tanstack/react-query";
import { downloadConfigFile } from "utils/downloadConfigFile";
import { useWorkspaceBlobClient } from "./useWorkspace";
import { Filter } from "odata-query";
import { resolveDynamicVariables } from "utils/resolveDynamicVariables";
import { getContextVariables } from "utils/getContextVariables";

export function useView(workspaceId: string, viewId: string) {
    const configFileName = `${viewId}/config.json`;

    const workspaceBlobClientQuery = useWorkspaceBlobClient(workspaceId);

    return useQuery({
        queryKey: ['view-configuration', viewId],
        queryFn: async () => {
            const blobClient = workspaceBlobClientQuery.data;
            const config = await downloadConfigFile<ViewConfig>(blobClient, configFileName);
            const serializedViewConfig = JSON.stringify(config);
            const variables = getContextVariables();
            return resolveDynamicVariables<ViewConfig>(serializedViewConfig, variables);
        },
        enabled: workspaceBlobClientQuery.isSuccess
    });
}

export type ViewConfig = {
    enablePreview: boolean,
    enableDownload: boolean,
    enableEdit: boolean,
    enableUpload: boolean,
    enableDelete: boolean,
    gridConfig: GridConfig,
    editFormConfig: EditFormConfig,
    uploadConfig: UploadConfig
}

export type GridConfig = {
    properties: string[],
    filter: Filter<any>[],
    orderBy: Filter<any>[],
    enableTags?: boolean
}

export type EditFormConfig = {
    properties: string[],
    enableTags?: boolean
}

export type UploadConfig = {
    properties: string[],
    fileTypes: [],
    maxFileSize: number,
    maxFileCount: number,
    enableTags?: boolean
}